<app-dialog [show]="show"
            [header]="'Invite Teammates'"
            [subHeader]="'Invite new users to join your team.'"
>
  <form *ngIf="show"
        @fadeInOut
        class="invite-form form"
        [formGroup]="inviteUserForm"
        (ngSubmit)="invite()"
  >
    <div class="inputs-wrapper" formArrayName="users"
         *ngFor="let item of inviteUserForm.get('users')['controls']; let i = index;"
    >
      <div class="inputs-container" [formGroupName]="i">
        <app-input class="half-width email"
                   formControlName="email"
                   [label]="i === 0 ? 'Teammate’s Work Email' : null"
                   [placeholder]="'user@example.com'"
                   type="email"
                   [autofocus]="show"
                   (keydownTab)="openDropdown(i)"
                   #emailInputList
        ></app-input>

        <app-dropdown class="half-width role"
                      [label]="i === 0 ? 'Role' : null"
                      [placeholder]="'Teammate\'s role'"
                      formControlName="role"
                      [isOptionObject]="true"
                      [options]="userRolesOptions"
                      [radioButtons]="true"
                      (tabEnterEvent)="afterDropdownClosed(i)"
                      (chosenOption)="afterDropdownClosed(i)"
                      #roleDropdownList
        ></app-dropdown>

        <div class="remove-btn-wrapper">
          <button [class.hidden]="i === 0"
                  [disabled]="i === 0"
                  (click)="removeInviteFormItem(i)"
                  type="button"
                  class="remove-btn animation-focus-default"
          >
            <img src="../../../../assets/icons/icon-remove-badge-dark-gray.svg" alt="remove-icon"/>
          </button>
        </div>

        <div *ngIf="failedEmailsFlags[i] && item.get('email').valid" class="email-error-message">
          This email is already in use
        </div>

        <div *ngIf="isEmailDuplicated(item.get('email')?.value, i) && !failedEmailsFlags[i] && item.get('email').valid"
             class="email-error-message">
          Emails cannot be duplicated
        </div>
      </div>
    </div>

    <input (click)="addInviteFormItem()"
           (keydown.enter)="addInviteFormItem()"
           [class.active]="inviteUserForm.get('users').valid"
           (keydown.tab)="focusButton('closeButton')"
           [tabIndex]="1"
           class="add-more-label animation-focus-default"
           value="+ Add More"
           readonly
           #addMoreLabel
    />


    <div class="dialog-controls-default">
      <app-button [minWidth]="0"
                  customClasses="px-4"
                  subStyle="transparent"
                  class="cancel-btn"
                  text="Cancel"
                  (clicked)="close()"
                  (keydownTab)="inviteUserForm.invalid || isSomeEmailDuplicated() ? focusInput(0) : focusButton('submitButton')"
                  [tabIndex]="2"
                  #closeButton
      ></app-button>
      <app-button customClasses="px-4"
                  [minWidth]="0"
                  class="invite-btn"
                  text="Send {{userItems.length}} Invite{{userItems.length !== 1 ? 's' : ''}}"
                  type="submit"
                  [disabled]="inviteUserForm.invalid || isSomeEmailDuplicated()"
                  (keydownTab)="focusInput(0)"
                  [tabIndex]="2"
                  #submitButton
      ></app-button>
    </div>
  </form>
</app-dialog>
